// @ts-nocheck

import React from 'react';
import { navigate } from '../../../lib/routerAdapter';
import notification from 'antd/lib/notification';
import { connect } from 'react-redux';

import styled from 'styled-components';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import moment from 'moment';

import { Header, Section } from '../../../components/layout';
import {
  cleanVehicle,
  fetchVehicle,
  updateVehicle } from
'../../../ducks/vehicle';


import Grid, { GridItem } from '../../../components/layout/Grid';
import Form from '../../../components/Form';
import { Selects } from '../../../components';
import OrgUnitSelect from '../../../components/OrgUnitSelect';
import { notificationLoading } from './../../../components/Notifications';
import CancelButton from '../../../components/CancelButton';

const StyledSection = styled(Section)`
  padding: 16px;
`;
const Footer = styled(Section)`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const { LocationSelect, CrewSelect } = Selects;










class Attachment extends React.Component {
  async componentDidMount() {
    const { vehicleId } = this.props;
    await this.props.cleanVehicle();
    try {
      await this.props.fetchVehicle(vehicleId);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  }

  onSubmit = async (values) => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      await this.props.updateVehicle(values);
      notification.success({
        message: 'Успешно сохранено',
        description: 'Изменения успешно сохранены'
      });
      navigate(`/vehicles/${values.id}/documentation/attachment`);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  handleCancel = () => {
    navigate(`/vehicles/${this.props.vehicleId}/documentation/attachment`);
  };

  formatDate = (value) => {
    return value ? moment.utc(value) : value;
  };

  render() {
    const { vehicle, employeeBranchOrgUnitId } = this.props;
    if (vehicle === null) return null;
    return (
      <>
        <Header
          left={vehicle && <h1>Прикрепление {vehicle.licensePlate}</h1>} />

        <Form initialValues={vehicle || {}} onSubmit={this.onSubmit}>
          {(FormField, formikProps) => {
            const {
              handleSubmit,
              handleBlur,
              handleFocus,
              setFieldValue,
              dirty
            } = formikProps;
            return (
              <form onSubmit={handleSubmit}>
                <StyledSection>
                  <Grid gutter="16px">
                    <GridItem style={{ overflow: 'hidden' }}>
                      <FormField
                        label="Служба закрепления/РЭС"
                        required
                        name="orgUnitId">

                        {({ value, name }) =>
                        <OrgUnitSelect
                          onChange={(value) => setFieldValue(name, value)}
                          onBlur={() => handleBlur({ target: { name } })}
                          name={name}
                          value={value} />

                        }
                      </FormField>
                    </GridItem>
                    <GridItem style={{ overflow: 'hidden' }}>
                      <FormField
                        label="Служба исользования/РЭС"
                        required
                        name="usingNodeId">

                        {({ value, name }) =>
                        <OrgUnitSelect
                          onChange={(value) => setFieldValue(name, value)}
                          onBlur={() => handleBlur({ target: { name } })}
                          name={name}
                          value={value} />

                        }
                      </FormField>
                    </GridItem>
                    <GridItem style={{ overflow: 'hidden' }}>
                      <FormField
                        label="Населенный пункт базирования ТС"
                        required
                        name="locationId">

                        {({ value, name }) =>
                        <LocationSelect
                          placeholder="Выберите место стоянки"
                          onChange={(value) =>
                          setFieldValue(name, value)
                          }
                          onFocus={handleFocus}
                          name={name}
                          filter={{
                            isDefault: true,
                            nodeId: employeeBranchOrgUnitId,
                            nodeFilterType: 'branchAndChildren'
                          }}
                          value={value} />

                        }
                      </FormField>
                    </GridItem>
                    <GridItem>
                      <FormField
                        fast
                        label="Место регистрации ТС"
                        name="registrationPlace"
                        required>

                        {(fieldProps) => <Input {...fieldProps} />}
                      </FormField>
                    </GridItem>
                    <GridItem style={{ overflow: 'hidden' }}>
                      <FormField label="Бригада" name="crewId">
                        {({ value, name }) =>
                        <CrewSelect
                          placeholder="Выберите бригаду"
                          onChange={(value) =>
                          setFieldValue(name, value)
                          }
                          name={name}
                          value={value} />

                        }
                      </FormField>
                    </GridItem>
                  </Grid>
                </StyledSection>
                <Footer>
                  <Button type="primary" htmlType="submit">
                    Сохранить
                  </Button>
                  <CancelButton dirty={dirty} onClick={this.handleCancel}>
                    Отменить
                  </CancelButton>
                </Footer>
              </form>);

          }}
        </Form>
      </>);

  }
}

export default connect(
  (state, props) => ({
    vehicle: state.vehicle,
    vehicleId: parseInt(props.vehicleId, 10),
    employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
  }),
  {
    fetchVehicle,
    cleanVehicle,
    updateVehicle
  }
)(Attachment);
